export const optionalRequest = async <T>(request: () => Promise<T>): Promise<T | undefined> => {
	try {
		return await request()
	} catch {
		return undefined
	}
}
